import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
            {contactInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-7">
            {contactInfo.desc}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-300/60 transition-all duration-300">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400 mb-0.5">爆料邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-300/60 transition-all duration-300">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400 mb-0.5">微信投稿</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
              </div>
            </div>
          </div>
          <div className="inline-flex items-start gap-2 p-4 bg-accent-50 rounded-xl border border-accent-200/60">
            <i className="ri-information-line text-accent-600 mt-0.5 flex-shrink-0"></i>
            <p className="text-xs md:text-sm text-accent-800 text-left">{contactInfo.tips}</p>
          </div>
        </div>
      </div>
    </section>
  );
}